/**
 * Forms.jsx - Re-export for backward compatibility
 * 
 * All form components have been refactored into separate files:
 * - /components/forms/BecomeTeacherForm.jsx
 * - /components/forms/BecomeSchoolForm.jsx
 * - /components/forms/CreateServiceForm.jsx
 * - /components/forms/CreateCourseForm.jsx
 * - /components/forms/formUtils.js (shared utilities)
 */

export { BecomeTeacherForm } from './forms/BecomeTeacherForm';
export { BecomeSchoolForm } from './forms/BecomeSchoolForm';
export { CreateServiceForm } from './forms/CreateServiceForm';
export { CreateCourseForm } from './forms/CreateCourseForm';

// Default export for backward compatibility
export default { 
  BecomeTeacherForm: require('./forms/BecomeTeacherForm').BecomeTeacherForm,
  BecomeSchoolForm: require('./forms/BecomeSchoolForm').BecomeSchoolForm,
  CreateServiceForm: require('./forms/CreateServiceForm').CreateServiceForm,
  CreateCourseForm: require('./forms/CreateCourseForm').CreateCourseForm,
};
